import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import TextWithCopy from '@/components/ui/custom/dataDisplay/TextWithCopy';
import { scheduledLessonsQueryKeys } from '@/data/services/querykeys';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { NotificationActionsProps } from '../../card/NotificationTypes';
import NotificationActions from './NotificationActions';

type DelayNotificationActionProps = NotificationActionsProps & {
  scheduledLessonId?: number;
};

export const DelayNotificationAction = ({
  scheduledLessonId,
  ...props
}: DelayNotificationActionProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'alerts.buttons',
  });
  const { data: scheduledLesson } = useQuery({
    ...scheduledLessonsQueryKeys.get(scheduledLessonId || 0),
    enabled: !!scheduledLessonId,
  });
  return (
    <NotificationActions
      {...props}
      addicionalActions={
        <ConditionalRenderer condition={scheduledLesson?.url}>
          <TextWithCopy
            label={t('copyLink')}
            target={scheduledLesson?.url}
            clickText
            className={{
              base: 'rounded-full bg-primary-content border-[1px] border-primary px-2 py-1 gap-1.5 cursor-pointer flex-row-reverse',
              text: 'text-primary text-14',
            }}
          />
        </ConditionalRenderer>
      }
    />
  );
};
